const attachmentListStrings = {
  filenameTableHeader: "Filnavn",
  labels: {
    downloadButton: "Last ned",
    removeButton: "@:commonStrings.remove"
  }
};

export default attachmentListStrings;